import { Skeleton } from '@mui/material';

function TopbarWidgetSkeleton() {
    return (
        <div className="SkeletonTopbar">
            <Skeleton height={50} variant="rounded" />
        </div>
    );
}

export { TopbarWidgetSkeleton };
